module.exports = "mutation ($id: ID!, $data: ResidentialAccountUpdate!) {\n  ResidentialAccountUpdate(id: $id, data: $data) {\n    id\n  }\n}\n"